import { AutocompleteInput, ReferenceInput, required, SimpleForm, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { SectionTitle } from "features/SectionTitle";
import { administrationRequests } from "api/administrationApi";

const SaveForm = ({ toolbar }) => {
  return (
    <SimpleForm toolbar={toolbar}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Дaнни за университета"
            paddingY={0}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Име на Университет"
            source="name"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <ReferenceInput
            source="countryId"
            reference={administrationRequests.getCountriesSelect()}
          >
            <AutocompleteInput
              label="Държава"
              validate={required()}
              optionText={"nameBg"}
              filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            />
          </ReferenceInput>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Град"
            source="city"
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Работен език"
            source="workingLanguage"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Еразъм код"
            source="erasmusCode"
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
        >
          <TextInput
            label="Линк"
            source="websiteLink"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <SectionTitle
            title="Дaнни за контакт с университета"
            paddingY={0}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Контакти"
            source="contact"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Имейл"
            source="email"
            validate={required()}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  );
};
export default SaveForm;
